import {
  ApplicationConfig,
  importProvidersFrom,
  SecurityContext,
} from "@angular/core";
import { provideRouter } from "@angular/router";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  BriPatientAuthorizationModule,
  BriTeammateAuthorizationModule,
} from "@davita/bridge-utility-library/authorization";
import { BriTeammateLoginModule } from "@davita/bridge-utility-library/login";
import { BriCommonHttpInterceptor } from "@davita/bridge-utility-library/core";
import { FetchRequestor, Requestor } from "@openid/appauth";
import { routes } from "./app.routes";
import { environment } from "../environments/environment";
import { provideMarkdown, MarkedOptions, MARKED_OPTIONS } from "ngx-markdown";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideMarkdown({
      sanitize: SecurityContext.HTML,
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: {
          breaks: true,
        },
      },
    }),
    importProvidersFrom(
      BriTeammateAuthorizationModule.forRoot(
        environment.authorization.teammate,
      ),
      BriPatientAuthorizationModule.forRoot(environment.authorization.patient),
      BriTeammateLoginModule,
    ),
    { provide: Requestor, useValue: new FetchRequestor() },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BriCommonHttpInterceptor,
      multi: true,
    },
  ],
};
